module.exports = __webpack_public_path__ + "static/media/shell32_15.ef8580f6.ico";